import { useMutation } from '@tanstack/react-query';
import iotApi from 'lib/api/iotApi.client';
import { ReportsQueryKey } from './reports.hooks.keys';

export function useGenerateFinanceReportMutation() {
  return useMutation({
    mutationKey: [ReportsQueryKey.GENERATE_FINANCE_REPORT],
    mutationFn: async () => {
      const res = await iotApi.reports.generateFinanceReport({});

      return res;
    },
  });
}
